window.addEventListener('load', function(){

    /****************************************
    * Configuration for Articles's Slider
    *****************************************/
    new Glider(document.querySelector('.midia').querySelector('.glider'), {
        slidesToShow: 1,
        slidesToScroll: 1,
        duration: .5,
        dots: document.querySelector('.midia').querySelector('.dots'),
        draggable: true,
        dragVelocity: 3.3,
        easing: function (x, t, b, c, d) {
            return c*(t/=d)*t + b;
        },
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    draggable: false,
                    arrows: {
                        prev: document.querySelector('.midia').querySelector('.glider-prev'),
                        next: document.querySelector('.midia').querySelector('.glider-next'),
                    }
                }
            },
        ]
    })

    /******************************************** 
    * Acordion effect for Medicos list items
    *********************************************/
     if(window.innerWidth < 1024){
        
        var medicosItems = document.getElementsByClassName('medico-item');
        for (i = 0; i < medicosItems.length; i++) {

            medicosItems[i].addEventListener("click", (e) => {
                
                // clear elms min-height & state
                for (i = 0; i < medicosItems.length; i++) {
                    if (medicosItems[i] != e.currentTarget){
                        medicosItems[i].ariaExpanded = 'false';
                    }
                    medicosItems[i].getElementsByClassName('item-paragraphs')[0].style.maxHeight = null;
                }
                
                // register elm description
                var description = e.currentTarget.getElementsByClassName('item-paragraphs')[0];  
                
                // current areaExpended State
                e.currentTarget.ariaExpanded = e.currentTarget.ariaExpanded !== 'true';
                var expended = (e.currentTarget.ariaExpanded === 'true');
                
                // add height to clicked item
                if(expended == true) {

                    description.style.maxHeight = description.scrollHeight + "px";
                }
            });
        }
    }
})